'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <section
      className="flex items-center justify-center px-5"
      style={{ minHeight: 'calc(100dvh - var(--nav-height))' }}
    >
      <div className="flex flex-col items-center gap-5 text-center max-w-md">
        <span
          className="font-mono text-rose"
          style={{
            color: 'var(--rose)',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.2em',
          }}
        >
          SOMETHING BROKE
        </span>
        <h1
          className="font-display italic text-text"
          style={{
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
          }}
        >
          Something went wrong
        </h1>
        <p className="text-text-secondary" style={{ fontSize: 15, lineHeight: 1.7 }}>
          Don&apos;t worry, it&apos;s not you, it&apos;s me. Try again, or head home and try a
          different path.
        </p>
        {error?.digest && (
          <code
            className="font-mono"
            style={{
              fontSize: 11,
              color: 'var(--text-muted)',
              background: 'var(--bg-subtle)',
              padding: '4px 10px',
              borderRadius: 6,
              border: '1px solid var(--border)',
            }}
          >
            {error.digest}
          </code>
        )}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
          <button
            onClick={reset}
            className="cta-primary inline-flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5"
            style={{
              background: 'linear-gradient(135deg, var(--accent), var(--indigo))',
              color: 'var(--bg-primary)',
              fontSize: 14,
              fontWeight: 800,
              padding: '13px 26px',
              borderRadius: 'var(--radius-lg)',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
          <Link
            href="/"
            className="cta-secondary inline-flex items-center justify-center transition-all duration-300"
            style={{
              background: 'transparent',
              color: 'var(--text-secondary)',
              fontSize: 14,
              fontWeight: 800,
              padding: '13px 26px',
              borderRadius: 'var(--radius-lg)',
              border: '1px solid var(--border)',
            }}
          >
            Go home
          </Link>
        </div>
      </div>
    </section>
  );
}
